import { render, staticRenderFns } from "./chat.vue?vue&type=template&id=6645851c&scoped=true&"
import script from "./chat.vue?vue&type=script&lang=ts&"
export * from "./chat.vue?vue&type=script&lang=ts&"
import style0 from "./chat.vue?vue&type=style&index=0&id=6645851c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6645851c",
  null
  
)

export default component.exports